'use client';

import { useEffect } from 'react';
import { VAULT_TERMS_AND_CONDITIONS_DO_NOT_SHOW_AGAIN_KEY } from 'src/constants/vaults/misc';
import useVelocityStore, {
	VelocityStore,
} from 'src/stores/VelocityStore/useVelocityStore';
import { isWindowDefined } from 'src/utils/browser';

// Add local storage keys here, that are to be synced with the VelocityStore
const LOCAL_STORAGE_KEYS: {
	key: string;
	storeKey: keyof VelocityStore;
	checkFn: (val: string) => any;
}[] = [
	{
		key: 'isGeoblocked',
		storeKey: 'isGeoblocked',
		checkFn: (val: string) => val === 'true',
	},
	{
		key: VAULT_TERMS_AND_CONDITIONS_DO_NOT_SHOW_AGAIN_KEY,
		storeKey: VAULT_TERMS_AND_CONDITIONS_DO_NOT_SHOW_AGAIN_KEY,
		checkFn: (val: string) => val === 'true',
	},
];

export const useHydrateVelocityStoreFromLocalStorage = () => {
	const setVelocityStore = useVelocityStore((s) => s.set);

	useEffect(() => {
		if (isWindowDefined() && window?.localStorage?.getItem) {
			LOCAL_STORAGE_KEYS.forEach(({ key, storeKey, checkFn }) => {
				const value = window.localStorage.getItem(key);
				if (!value) return;
				const parsedValue = checkFn(value);

				setVelocityStore((s) => {
					// @ts-ignore
					s[storeKey] = parsedValue;
				});
			});
		}
	}, []);
};
